import { Ability } from '@core/abilities-types';
import { GettingStartedStep, GettingStartedSubtask } from '@core/getting-started-types';

export const GettingStartedAbilitiesMap: Record<GettingStartedSubtask, Ability[]> = {
  [GettingStartedSubtask.WelcomeVideo]: [],
  [GettingStartedSubtask.NavigationTour]: [],
  [GettingStartedSubtask.SetUpRoles]: [Ability.ManageRecruiters],
  [GettingStartedSubtask.InviteYourTeam]: [Ability.ManageRecruiters],
  [GettingStartedSubtask.AdjustNotifications]: [],
  [GettingStartedSubtask.SyncCalendarAndEmail]: [
    Ability.ViewCalendar,
    Ability.ManageEmailIntegrations,
  ],
  [GettingStartedSubtask.BuildHiringPipeline]: [Ability.ManagePipelineTemplates],
  [GettingStartedSubtask.SeeHowDisqualifyReasonsWork]: [Ability.ManageDisqualifyReasons],
  [GettingStartedSubtask.AddAdmin]: [Ability.ManageRecruiters],
  [GettingStartedSubtask.CreateWebsiteAddress]: [Ability.ManageCompany],
  [GettingStartedSubtask.CustomizeYourSite]: [Ability.EditCareersSite],
  [GettingStartedSubtask.CreateJob]: [
    Ability.ManageJobs,
    Ability.AssignUsersToJobs,
    Ability.ManageAutomatedActions,
    Ability.AssignUsersToJobs,
    Ability.ManageOpenQuestions,
  ],
  [GettingStartedSubtask.PublishJob]: [
    Ability.ViewCandidates,
    Ability.ViewJobs,
    Ability.ViewAllJobs,
    Ability.ManageJobs,
    Ability.PublishJobs,
    Ability.FreeJobsBoards,
  ],
  [GettingStartedSubtask.PipelineOverview]: [
    Ability.ViewCandidates,
    Ability.ManageCandidates,
    Ability.ViewJobs,
    Ability.ViewAllJobs,
    Ability.ManageJobs,
  ],
  [GettingStartedSubtask.ScheduleCandidateInterview]: [
    Ability.ManageCandidates,
    Ability.SendEmails,
  ],
  [GettingStartedSubtask.CollaborativeHiring]: [
    Ability.ViewCandidates,
    Ability.ManageCandidates,
    Ability.ShareCandidates,
  ],
  [GettingStartedSubtask.EvaluateCandidates]: [
    Ability.ViewCandidates,
    Ability.ManageCandidates,
    Ability.ViewAllJobs,
  ],
  [GettingStartedSubtask.ProceedOrDisqualify]: [Ability.ManageHiredCandidates, Ability.ViewAllJobs],
  [GettingStartedSubtask.ConnectYourTools]: [],
  [GettingStartedSubtask.DiscoverNewApps]: [],
  [GettingStartedSubtask.BrowsePublishedJobs]: [Ability.ViewAllJobs],
  [GettingStartedSubtask.CreateEmailTemplates]: [Ability.ManageEmailTemplates],
  [GettingStartedSubtask.WriteJobDescriptions]: [Ability.ManageJobs],
};

export const GettingStartedNoAbilitiesMap = {
  [GettingStartedSubtask.BrowsePublishedJobs]: [Ability.ManageJobs], // User will see section only if don don't have this ability
};

export const visitOurMarketplaceSubtasks = [
  GettingStartedSubtask.ConnectYourTools,
  GettingStartedSubtask.DiscoverNewApps,
];

export const postYourFirstJobSubtasks = [
  GettingStartedSubtask.CreateJob,
  GettingStartedSubtask.PublishJob,
];

export const manageCandidatesSubtasks = [
  GettingStartedSubtask.PipelineOverview,
  GettingStartedSubtask.ScheduleCandidateInterview,
  GettingStartedSubtask.CollaborativeHiring,
  GettingStartedSubtask.EvaluateCandidates,
  GettingStartedSubtask.ProceedOrDisqualify,
];

export const getStartedSubtasks = [
  GettingStartedSubtask.WelcomeVideo,
  GettingStartedSubtask.NavigationTour,
  GettingStartedSubtask.SetUpRoles,
  GettingStartedSubtask.InviteYourTeam,
  GettingStartedSubtask.AdjustNotifications,
];

export const createCareersSiteSubtasks = [
  GettingStartedSubtask.AddAdmin,
  GettingStartedSubtask.CreateWebsiteAddress,
  GettingStartedSubtask.CustomizeYourSite,
];

export const adjustSettingsSubtasks = [
  GettingStartedSubtask.SyncCalendarAndEmail,
  GettingStartedSubtask.BuildHiringPipeline,
  GettingStartedSubtask.SeeHowDisqualifyReasonsWork,
];

export const composeYourMessagingSubtasks = [
  GettingStartedSubtask.CreateEmailTemplates,
  GettingStartedSubtask.WriteJobDescriptions,
];

export const viewJobsSubtasks = [GettingStartedSubtask.BrowsePublishedJobs];

export const gettingStartedConfiguration = [
  {
    step: GettingStartedStep.GetStarted,
    subtasks: getStartedSubtasks,
  },
  {
    step: GettingStartedStep.AdjustSettings,
    subtasks: adjustSettingsSubtasks,
  },
  {
    step: GettingStartedStep.ViewJobs,
    subtasks: viewJobsSubtasks,
  },
  {
    step: GettingStartedStep.CreateCareersSite,
    subtasks: createCareersSiteSubtasks,
  },
  {
    step: GettingStartedStep.ComposeYourMessaging,
    subtasks: composeYourMessagingSubtasks,
  },
  {
    step: GettingStartedStep.PostYourFirstJob,
    subtasks: postYourFirstJobSubtasks,
  },
  {
    step: GettingStartedStep.ManageCandidates,
    subtasks: manageCandidatesSubtasks,
  },
  {
    step: GettingStartedStep.VisitOurMarketplace,
    subtasks: visitOurMarketplaceSubtasks,
  },
];
